import { PARTIES, PARTY_ORDER, type GlobalAggregate } from '../lib/types';

interface Props {
  totals: GlobalAggregate['totals'];
}

export function PlayerShare({ totals }: Props) {
  const pcts = totals.usersByPartyPct;
  if (!pcts) return null;

  return (
    <section className="section span-2">
      <h2>Vilket parti har spelarna valt?</h2>
      <p className="updated-at">Andel av alla spelare, oavsett hur det går på kartan</p>
      {PARTY_ORDER.map(partyId => {
        const pct = pcts[partyId] ?? 0;
        return (
          <div className="stat-row" key={partyId}>
            <span className="label">
              <span
                className="color-dot"
                style={{ background: PARTIES[partyId].color, marginRight: 8 }}
              />
              {partyId}
            </span>
            <span className="bar-track">
              <span
                className="bar-fill"
                style={{ width: `${pct}%`, background: PARTIES[partyId].color }}
              />
            </span>
            <span className="value">{pct.toFixed(1)}%</span>
          </div>
        );
      })}
    </section>
  );
}
